import AdvertiserNavbar from '../../Advertiser/AdvertiserNavBar/AdvertiserNavBar'
import RatePitchSummaryContent from './RatePitchSummaryContent'

const RatePitchSummary = ({ }) => {


    return (
        <>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Rate Pitch Summary</h1>
            </div>
            <RatePitchSummaryContent />

        </>
    )
}

export default RatePitchSummary
